import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useMaterialUIController } from "context";
import CTLDialogContent from "../styles/CTLDialogContent";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { setAuthentication } from "context";
import { setActivePage } from "context";

const CTLBackButtonAction = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [pendingBack, setPendingBack] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode, activePage } = controller;
  useEffect(() => {
    const handlePopState = (event) => {
      if (location.pathname.includes("/app/home")) {
        event.preventDefault();
        setOpenConfirmDialog(true);
        setPendingBack(true);
        window.history.pushState(null, "", window.location.pathname);
      }
    };

    window.history.pushState(null, "", window.location.pathname);

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location]);

  const handleConfirmLeave = () => {
    setOpenConfirmDialog(false);
    if (pendingBack) {
      setPendingBack(false);
      AuthenticationService.logout();
      activePage.authenticationStatus = false;
      setActivePage(dispatch, activePage);
      setAuthentication(dispatch, false);
      navigate("/site/log-out", { replace: true });
    }
  };

  const handleStay = () => {
    setOpenConfirmDialog(false);
    setPendingBack(false);
  };

  return (
    <div>
      <Dialog
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
        open={openConfirmDialog}
        onClose={handleStay}
      >
        <DialogContent sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDTypography variant="body1">
            This action will log you out. Do you want to continue?
          </MDTypography>
        </DialogContent>
        <DialogActions sx={(theme) => CTLDialogContent(theme, { darkMode })}>
          <MDButton onClick={handleConfirmLeave} color="error" autoFocus>
            Yes
          </MDButton>
          <MDButton onClick={handleStay} color="success">
            No
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CTLBackButtonAction;
